<template>
  <div class="form-group">
    <label class="mb-1" :for="displayId">{{ label }}</label>
    <div class="input-group date-text-picker-group">
      <input
        ref="displayInputRef"
        :id="displayId"
        :type="inputType"
        :inputmode="inputType === 'text' ? 'numeric' : null"
        autocomplete="bday"
        :placeholder="inputType === 'text' ? 'TT.MM.JJJJ' : null"
        :maxlength="inputType === 'text' ? 10 : null"
        :value="visibleValue"
        :readonly="readonly"
        :class="[
          'form-control', 'datepicker',
          { 'readonly-field': readonly }
        ]"
        @input="onDisplayInput"
        @change="onDateNativeChange"
        @blur="onDisplayBlur"
        @keydown="onDisplayKeydown"
      >
      <button
        v-if="!readonly"
        type="button"
        class="btn btn-outline-secondary date-text-picker-toggle"
        :aria-label="toggleAriaLabel"
        @click="onToggleClick"
      >
        <svg v-if="inputType === 'text'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
          <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM2 2a1 1 0 0 0-1 1v1h14V3a1 1 0 0 0-1-1H2zm13 3H1v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V5z"/>
          <path d="M3.5 7a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H7a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zM3.5 10a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H7a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm-6 2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H7a.5.5 0 0 1-.5-.5z"/>
        </svg>
        <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
          <path d="M14 5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h12zM2 4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H2z"/>
          <path d="M13 10.25a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5zm-5 0a.25.25 0 0 1 .25-.25h3.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-3.5a.25.25 0 0 1-.25-.25v-.5zm-5 0a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5zm1.5 0a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5zm1.5 0a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5zM2 8.25a.25.25 0 0 1 .25-.25h.5A.25.25 0 0 1 3 8.25v.5a.25.25 0 0 1-.25.25h-.5A.25.25 0 0 1 2 8.75v-.5zm2 0a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5A.25.25 0 0 1 4 8.75v-.5zM6 8.25a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5A.25.25 0 0 1 6 8.75v-.5zm2 0a.25.25 0 0 1 .25-.25h.5A.25.25 0 0 1 9 8.25v.5a.25.25 0 0 1-.25.25h-.5A.25.25 0 0 1 8 8.75v-.5zm2 0a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5zm2 0a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5zM2 6.25a.25.25 0 0 1 .25-.25h.5A.25.25 0 0 1 3 6.25v.5a.25.25 0 0 1-.25.25h-.5A.25.25 0 0 1 2 6.75v-.5zm2 0a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5A.25.25 0 0 1 4 6.75v-.5zm2 0a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5A.25.25 0 0 1 6 6.75v-.5zm2 0a.25.25 0 0 1 .25-.25h.5A.25.25 0 0 1 9 6.25v.5a.25.25 0 0 1-.25.25h-.5A.25.25 0 0 1 8 6.75v-.5zm2 0a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5zm2 0a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5z"/>
        </svg>
      </button>
    </div>

    <input
      ref="validationInputRef"
      type="text"
      class="date-text-picker-validation"
      :id="id"
      :name="id"
      :value="modelValue"
      tabindex="-1"
      aria-hidden="true"
      autocomplete="off"
      @focus="onValidationFocus"
    >
  </div>
</template>

<script>
export default {
  name: "DateTextPickerField",
  props: {
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: false,
      default: ''
    },
    modelValue: {
      type: String,
      required: false,
      default: ''
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      displayValue: '',
      inputType: 'text'
    };
  },
  computed: {
    displayId() {
      return `${this.id}_display`;
    },
    visibleValue() {
      return this.inputType === 'text' ? this.displayValue : (this.modelValue || '');
    },
    toggleAriaLabel() {
      return this.inputType === 'text'
        ? (this.label ? `${this.label} auswählen` : 'Datum auswählen')
        : 'Tastatur-Eingabe';
    }
  },
  watch: {
    modelValue: {
      immediate: true,
      handler(newIso) {
        // Externer Update (Initialwert, Picker, Reset etc.) → Display synchronisieren,
        // wenn der aktuelle Display-Wert nicht ohnehin schon zum gleichen ISO parst.
        const currentIsoFromDisplay = this.displayToIso(this.displayValue);
        if (currentIsoFromDisplay !== (newIso || '')) {
          this.displayValue = this.isoToDisplay(newIso || '');
        }
      }
    }
  },
  mounted() {
    if (typeof MutationObserver !== 'undefined' && this.$refs.validationInputRef) {
      // FormValidation hängt is-invalid/is-valid an das versteckte Validation-Input.
      // Wir spiegeln das auf den sichtbaren Display-Input, damit Bootstrap 5 die rote
      // Umrandung am tatsächlich sichtbaren Feld anzeigt.
      this._classObserver = new MutationObserver(() => this.syncValidationClasses());
      this._classObserver.observe(this.$refs.validationInputRef, {
        attributes: true,
        attributeFilter: ['class']
      });
      this.syncValidationClasses();
    }
  },
  beforeUnmount() {
    if (this._classObserver) {
      this._classObserver.disconnect();
      this._classObserver = null;
    }
  },
  methods: {
    isoToDisplay(iso) {
      if (!iso || typeof iso !== 'string') return '';
      const m = iso.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (!m) return '';
      return `${m[3]}.${m[2]}.${m[1]}`;
    },
    displayToIso(display) {
      if (!display || typeof display !== 'string') return '';
      const m = display.match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
      if (!m) return '';
      return `${m[3]}-${m[2]}-${m[1]}`;
    },
    applyMask(raw) {
      if (!raw) return '';
      // Browser-/OS-Autofill kann einen kompletten ISO-Wert einsetzen → direkt umformatieren,
      // statt bloß die Ziffern zu maskieren (würde sonst zu "19.90.0501" verstümmeln).
      const isoMatch = raw.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (isoMatch) {
        return `${isoMatch[3]}.${isoMatch[2]}.${isoMatch[1]}`;
      }
      const digits = raw.replace(/\D/g, '').slice(0, 8);
      if (digits.length <= 2) return digits;
      if (digits.length <= 4) return `${digits.slice(0, 2)}.${digits.slice(2)}`;
      return `${digits.slice(0, 2)}.${digits.slice(2, 4)}.${digits.slice(4)}`;
    },
    onDisplayInput(event) {
      if (this.inputType === 'date') {
        // Native Date-Input: value ist immer ISO YYYY-MM-DD (oder leer).
        const iso = event.target.value || '';
        this.displayValue = this.isoToDisplay(iso);
        if (iso !== (this.modelValue || '')) {
          this.$emit('update:modelValue', iso);
        }
        this.dispatchValidationChange();
        return;
      }

      const target = event.target;
      const rawValue = target.value;
      const cursorWasAtEnd = target.selectionStart === rawValue.length;
      const masked = this.applyMask(rawValue);

      this.displayValue = masked;

      if (rawValue !== masked) {
        target.value = masked;
        if (cursorWasAtEnd) {
          this.$nextTick(() => {
            try { target.setSelectionRange(masked.length, masked.length); } catch (e) { /* noop */ }
          });
        }
      }

      const iso = this.displayToIso(masked);
      if (iso !== (this.modelValue || '')) {
        this.$emit('update:modelValue', iso);
      }
    },
    onDateNativeChange(event) {
      // 'change' feuert auf iOS/Android-Pickern erst beim Schließen/Bestätigen,
      // auf Desktop redundant zu 'input' — daher hier nur im Date-Modus aktiv.
      if (this.inputType !== 'date') return;
      const iso = event.target.value || '';
      this.displayValue = this.isoToDisplay(iso);
      if (iso !== (this.modelValue || '')) {
        this.$emit('update:modelValue', iso);
      }
      this.$nextTick(() => this.dispatchValidationChange());
    },
    onDisplayBlur() {
      // FormValidation lauscht auf 'change' am Validation-Input (name=id). Vue ändert dort
      // den Wert per Property-Binding ohne nativen Event → daher manuell dispatchen.
      this.dispatchValidationChange();
    },
    onDisplayKeydown(event) {
      if (this.inputType !== 'text') return;
      if (event.key !== 'Backspace') return;
      const target = event.target;
      const start = target.selectionStart;
      const end = target.selectionEnd;
      if (start !== end || start <= 0) return;
      if (target.value.charAt(start - 1) !== '.') return;

      // Cursor steht direkt hinter einem automatisch eingesetzten Punkt → mit der Ziffer davor
      // gemeinsam löschen, damit die Maske natürlich zurücktippbar ist.
      event.preventDefault();
      const newRaw = target.value.slice(0, start - 2) + target.value.slice(start);
      const masked = this.applyMask(newRaw);
      this.displayValue = masked;
      target.value = masked;
      const newPos = Math.max(0, start - 2);
      this.$nextTick(() => {
        try { target.setSelectionRange(newPos, newPos); } catch (e) { /* noop */ }
      });
      const iso = this.displayToIso(masked);
      if (iso !== (this.modelValue || '')) {
        this.$emit('update:modelValue', iso);
      }
    },
    async onToggleClick() {
      if (this.inputType === 'text') {
        this.inputType = 'date';
        await this.$nextTick();
        const el = this.$refs.displayInputRef;
        if (!el) return;
        try {
          if (typeof el.showPicker === 'function') {
            el.showPicker();
            return;
          }
        } catch (e) {
          // showPicker kann werfen (z. B. nicht user-initiated) → Fallback unten
        }
        try { el.focus(); } catch (e) { /* noop */ }
      } else {
        this.inputType = 'text';
        await this.$nextTick();
        const el = this.$refs.displayInputRef;
        if (el) {
          try { el.focus(); } catch (e) { /* noop */ }
          const len = (this.displayValue || '').length;
          this.$nextTick(() => {
            try { el.setSelectionRange(len, len); } catch (e) { /* noop */ }
          });
        }
      }
    },
    onValidationFocus() {
      // Falls der versteckte Input dennoch fokussiert wird (assistive Tech), Fokus weiterreichen.
      const display = this.$refs.displayInputRef;
      if (display && typeof display.focus === 'function') {
        display.focus();
      }
    },
    dispatchValidationChange() {
      const el = this.$refs.validationInputRef;
      if (!el) return;
      try {
        el.dispatchEvent(new Event('change', { bubbles: true }));
      } catch (e) {
        const ev = document.createEvent('HTMLEvents');
        ev.initEvent('change', true, false);
        el.dispatchEvent(ev);
      }
    },
    syncValidationClasses() {
      const valEl = this.$refs.validationInputRef;
      const dispEl = this.$refs.displayInputRef;
      if (!valEl || !dispEl) return;
      ['is-invalid', 'is-valid'].forEach(cls => {
        if (valEl.classList.contains(cls)) {
          dispEl.classList.add(cls);
        } else {
          dispEl.classList.remove(cls);
        }
      });
    }
  }
};
</script>

<style scoped>
.readonly-field {
  background-color: #e9ecef;
  color: #6c757d;
  cursor: not-allowed;
}

.date-text-picker-group {
  flex-wrap: nowrap;
}

/* Validation-Input visuell verstecken, aber "renderbar" lassen, damit
   FormValidation es nicht als :hidden ausschließt. */
.date-text-picker-validation {
  position: absolute;
  left: -9999px;
  top: 0;
  width: 1px;
  height: 1px;
  opacity: 0;
  border: 0;
  padding: 0;
  margin: 0;
  pointer-events: none;
  overflow: hidden;
}

.date-text-picker-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 2.5rem;
}
</style>
